import { render, staticRenderFns } from "./addMessage.vue?vue&type=template&id=3214182b&"
import script from "./addMessage.vue?vue&type=script&lang=js&"
export * from "./addMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3214182b')) {
      api.createRecord('3214182b', component.options)
    } else {
      api.reload('3214182b', component.options)
    }
    module.hot.accept("./addMessage.vue?vue&type=template&id=3214182b&", function () {
      api.rerender('3214182b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/addMessage.vue"
export default component.exports